module.exports = __webpack_public_path__ + "static/media/zahod.e7d6b241.png";